import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GridRenderCellParams, GridTreeNodeWithRender } from "@mui/x-data-grid";
import { Box, Chip, Link, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { getEmailListStatusColor } from "../../../shared/functions/getChipColors";
import React from "react";
import { ErrorOutlineOutlined } from "@mui/icons-material";

export const useEmailListPreviewColumns = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return [
    { field: "id", headerName: t("general.id"), width: 80 },
    {
      field: "companyName",
      headerName: t("emails.companyName"),
      flex: 1,
      minWidth: 250,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => {
            navigate(`/email-list/preview/${params?.row?.id}`);
          }}
        >
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "email",
      headerName: t("general.email"),
      width: 250,
    },
    {
      field: "fullName",
      headerName: t("emails.fullName"),
      width: 200,
    },
    {
      field: "status",
      headerName: t("general.status"),
      width: 100,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <Chip
            label={t(`emails.${params.value}`)}
            color={getEmailListStatusColor(params.value)}
            variant="outlined"
          />
          {params?.value === "FAILED" && params?.row?.lastError && (
            <Box sx={{ ml: "5px" }} className={"cursor-pointer"}>
              <Tooltip title={params?.row?.lastError ?? ""}>
                <div style={{ display: "flex" }}>
                  <ErrorOutlineOutlined color={"error"} fontSize={"small"} />
                </div>
              </Tooltip>
            </Box>
          )}
        </Box>
      ),
    },

    {
      field: "websiteUrl",
      headerName: t("emails.websiteUrl"),
      width: 100,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) =>
        params?.value ? (
          <Link
            href={params?.value}
            target="_blank"
            rel="noopener"
            sx={{
              padding: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box>
              <OpenInNewIcon fontSize="inherit" />
            </Box>
          </Link>
        ) : (
          "-"
        ),
    },
  ];
};
